import React from "react";
import styles from "./ChatMessage.module.css";

export interface ChatMessageProps {
  text: string;
  sender: string;
  timeLabel: string;
  isOutgoing: boolean;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ text, sender, timeLabel, isOutgoing }) => {
  const footerTime = timeLabel ? timeLabel : "";
  const normalizedSender = String(sender ?? "").trim().toLowerCase();
  const authorLabel = isOutgoing || normalizedSender === "client" ? "Вы" : sender;

  return (
    <div className={`${styles.row} ${isOutgoing ? styles.row_outgoing : styles.row_incoming}`}>
      <article className={styles.bubble}>
        <footer className={styles.meta}>
          <span className={styles.author}>{authorLabel}</span>
          {footerTime ? <span className={styles.time}>{footerTime}</span> : null}
        </footer>
        <div className={styles.text}>{text}</div>
      </article>
    </div>
  );
};

export default ChatMessage;
